import Icon from "@ant-design/icons"
import React from "react"

const purchaseOrderTag = () => (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.10964 16.418C6.79297 15.6846 7.83464 15.743 8.43464 16.543L9.2763 17.668C9.9513 18.5596 11.043 18.5596 11.718 17.668L12.5596 16.543C13.1596 15.743 14.2013 15.6846 14.8846 16.418C16.368 18.0013 17.5763 17.4763 17.5763 15.2596V5.86797C17.5846 2.50964 16.8013 1.66797 13.6513 1.66797H7.3513C4.2013 1.66797 3.41797 2.50964 3.41797 5.86797V15.2513C3.41797 17.4763 4.63464 17.993 6.10964 16.418Z"
            stroke="#02C2A6"
            stroke-width="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M7.24609 9.16797H7.25358" stroke="#02C2A6" stroke-width="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.58203 9.16797H14.1654" stroke="#02C2A6" stroke-width="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.24609 5.83203H7.25358" stroke="#02C2A6" stroke-width="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.58203 5.83203H14.1654" stroke="#02C2A6" stroke-width="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const PurchaseOrderTagIcon = (props: any) => <Icon component={purchaseOrderTag} {...props} />
